import React from 'react'
import CustomTable from '../../../elements/Table/CustomTable'
import { Button, Select } from "antd";
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import DateCell from '../../../elements/Table/Cells/DateCell'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import qs from 'query-string'
import MoneyCell from '../../../elements/Table/Cells/MoneyCell'
const columns = [
  {
    Header: 'ID',
    accessor: '_id',
    width: 200,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Vendor Quote No',
    accessor: 'quoteNo',
    width: 200,
    Cell: ({ value, original }) => (
      <Link
        to={{
          pathname: `/purchasing/vendor/quotes/${original._key}/update`,
        }}
        //target={'_blank'}>
      >
        {value}
      </Link>
    ),
  },
  {
    Header: 'RFQ Code',
    accessor: 'rfq.code',
    width: 150,
    hideable: true,
    hideDefault: false
  },
  {
    Header: 'Enquiry',
    accessor: 'enquiry.code',
    width: 150,
    hideable: true,
    hideDefault: false
  },
  { Header: 'Title', accessor: 'title', style: { textAlign: 'left', marginLeft: 5 } },
  {
    Header: 'Vendor',
    accessor: 'vendor.fn',
    width: 300,
    style: { textAlign: 'left', marginLeft: 5 },
  },
  {
    Header: 'Net',
    accessor: 'amount.net',
    width: 100,
    Cell: MoneyCell,
    hideable: true,
    hideDefault: false
  },
  {
    Header: 'VendorRep',
    accessor: 'vendorRep.fn',
    style: { textAlign: 'left', marginLeft: 5 },
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    style: { textAlign: 'left', marginLeft: 5 },
    width: 300,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Buyer',
    accessor: 'companyRep.fn',
    style: { textAlign: 'left', marginLeft: 5 },
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Responded',
    accessor: 'date.quote',
    width: 120,
    hideable: true,
    hideDefault: true,
    Cell: DateCell,
  },
  {
    Header: 'Validity End',
    accessor: 'date.validity',
    width: 120,
    hideable: true,
    hideDefault: false,
    Cell: DateCell,
  },
  { Header: 'Status', accessor: 'status', width: 150,
    Cell: StatusCell,
    filterMethod: (filter, row) => {
      const activeArray = ['Confirmed', 'Revised', 'Draft','Expired']
      const expiredArray = ['Expired']
      const draftArray = ['Draft']
      const revisedArray = ['Revised']
      const nonActiveArray = ['Closed', 'Delivered', 'Cancelled']
      if (filter.value === 'all') {
        return true
      }
      if (filter.value === 'draft') {
        return draftArray.includes(row[filter.id])
      }
      if (filter.value === 'revised') {
        return revisedArray.includes(row[filter.id])
      }
      if (filter.value === 'expired') {
        return expiredArray.includes(row[filter.id])
      }
      return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={'draft'}>Draft</Select.Option>
        <Select.Option value={'revised'}>Revised</Select.Option>
        <Select.Option value={'expired'}>Expired</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
]

function VendorQuotesList(props) {
  const { list, fetch, fetching, company, onChangeCompany, hideCompany, vendorID, rfqID } = props
  return (
    <CustomTable
      data={list}
      defaultPageSize={20}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      ExtraOptionsButtons={() =>
        hideCompany !== true && (
          <OrganisationsSelect
            value={company}
            onChange={onChangeCompany}
            placeholder={'Filter by a company'}
            size={'small'}
            style={{ width: '450px', paddingRight: 20, float: 'right' }}
          />
        )
      }
      CreateButton={() => (
        <Button
          type={'primary'}
          size="small"
          icon={'plus'}
          onClick={() => {
            props.history.push({
              pathname: '/purchasing/vendor/quotes/new/',
              search: qs.stringify({
                vendorID,
                rfqID,
              }),
            })
          }}>
          New
        </Button>
      )}
      columns={columns}
    />
  )
}

VendorQuotesList.propTypes = {
  list: PropTypes.any,
  fetch: PropTypes.any,
  fetching: PropTypes.any,
  company: PropTypes.any,
  onChangeCompany: PropTypes.any,
  hideCompany: PropTypes.bool,
}
VendorQuotesList.defaultProps = {}

export default withRouter(VendorQuotesList)
